import * as React from 'react';
import './style/index.scss';

interface SubmissionSuccessFormProps {
    ticketId: Nullable<number>;
    onClickNewRequest: () => void;
}

export class SubmissionSuccessForm extends React.Component<SubmissionSuccessFormProps> {
    render(): React.ReactNode {
        return (
            <React.Fragment>
                {this.renderForm()}
            </React.Fragment>
        );
    }

    private renderForm(): React.ReactNode {
        const confirmationMessage = 'Your support request has been submitted.';
        return (
            <div className="submission-success-form">
                <i className="submission-success-form__image icon-check"/>
                <h1 className="submission-success-form__header">Thank you</h1>
                <p className="submission-success-form__sub-header">
                   {confirmationMessage}
                </p>
                <p>
                    You will receive an email confirmation for this
                    request and may reply to that email with
                    additional information regarding this ticket.
                </p>
                <p>
                    <a id="new-support-request" onClick={this.props.onClickNewRequest}>Submit another request</a>
                </p>
            </div>
        );
    }
}